/*
 * This file is released under the MIT license.
 * Copyright (c) 2023, Mike Lischke
 *
 * See LICENSE file for more info.
 */

import { VariableSymbol } from "./VariableSymbol";

export class ParameterSymbol extends VariableSymbol { }
